/**
 * 学习乐园 · 连连看题材包：诗人配朝代（lianliankan/pack-shiren.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：诗人连「朝代·称谓」（「李白」连「盛唐·诗仙」）。
 * 口径如实：右牌不是单一个朝代字——「唐」会有七八位诗人共用，两张牌面
 * 一跨对重复，配错反馈就指不准搭档（页面红线：rel 型牌面必须唯一）。
 * 于是把朝代与称谓合成一张牌：称谓本身就是文学常识（诗仙、诗圣、
 * 诗佛、诗鬼、易安居士、五柳先生……），朝代、人物、称号一次配齐。
 * note 顺手带一句代表作，配上就能念出来。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.shiren = {
    id: 'shiren',
    name: '诗人配朝代',
    hint: '诗人连朝代与称谓',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '李白', r: '盛唐·诗仙', note: '床前明月光' },
      { l: '杜甫', r: '盛唐·诗圣', note: '两个黄鹂鸣翠柳' },
      { l: '王维', r: '盛唐·诗佛', note: '诗中有画，晚年向佛' },
      { l: '孟浩然', r: '盛唐·山水田园', note: '春眠不觉晓' },
      { l: '王昌龄', r: '盛唐·七绝圣手', note: '秦时明月汉时关' },
      { l: '白居易', r: '中唐·诗魔', note: '写诗到口舌生疮' },
      { l: '刘禹锡', r: '中唐·诗豪', note: '前度刘郎今又来' },
      { l: '李贺', r: '中唐·诗鬼', note: '诗风奇诡，二十七岁早逝' },
      { l: '杜牧', r: '晚唐·小杜', note: '千里莺啼绿映红' },
      { l: '李商隐', r: '晚唐·无题圣手', note: '相见时难别亦难' },
      { l: '苏轼', r: '北宋·东坡', note: '号东坡居士，把酒问青天' },
      { l: '王安石', r: '北宋·临川', note: '春风又绿江南岸' },
      { l: '李清照', r: '南宋·易安居士', note: '生当作人杰的婉约词宗' },
      { l: '陆游', r: '南宋·放翁', note: '王师北定中原日' },
      { l: '辛弃疾', r: '南宋·稼轩', note: '醉里挑灯看剑' },
      { l: '陶渊明', r: '东晋·五柳先生', note: '采菊东篱下' },
      { l: '屈原', r: '战国·楚辞之祖', note: '端午节就是纪念他' },
      { l: '曹植', r: '三国·七步成诗', note: '煮豆燃豆萁' },
      { l: '王勃', r: '初唐·四杰之首', note: '海内存知己，天涯若比邻' },
      { l: '贺知章', r: '盛唐·四明狂客', note: '笑问客从何处来' },
      { l: '岑参', r: '盛唐·边塞诗人', note: '忽如一夜春风来' },
      { l: '韩愈', r: '中唐·文起八代', note: '天街小雨润如酥' },
      { l: '柳宗元', r: '中唐·唐宋八家', note: '千山鸟飞绝' },
      { l: '贾岛', r: '中唐·推敲诗人', note: '僧敲月下门，一字之师' },
      { l: '文天祥', r: '南宋·正气诗人', note: '人生自古谁无死' },
      { l: '龚自珍', r: '晚清·己亥诗人', note: '不拘一格降人才' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
